import * as React from 'react';
import PropTypes from 'prop-types';
// material
import { Container, Stack, Typography, Box, Tabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';

//
// components
import Page from '../components/Page';
import { PasswordChange, Privacy, UnitsChose } from '../components/profile';
import { MHidden } from '../components/@material-extend';
import { useTranslation } from '../common/LocalizationProvider';
// ----------------------------------------------------------------------

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  };
}

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '50vh',
  padding: theme.spacing(12, 0)
}));

export default function SettingsProfile() {
  const t = useTranslation();
  const [valueTabs, setValueTabs] = React.useState(0);

  const handleChangeTabs = (event, newValue) => {
    setValueTabs(newValue);
  };
  return (
    <Page title={t('STG_Title')}>
      <Container>
        <Typography variant="h4" sx={{ mb: 5 }}>
          {t('settings')}
        </Typography>

        <MHidden width="smUp">
          <Tabs value={valueTabs} onChange={handleChangeTabs} aria-label="basic tabs">
            <Tab label={t('STG_Privacy')} {...a11yProps(0)} sx={{ textTransform: 'none' }} />
            <Tab label={t('STG_Units')} {...a11yProps(0)} sx={{ textTransform: 'none' }} />
            <Tab label={t('STG_ChangePassword')} {...a11yProps(1)} sx={{ textTransform: 'none' }} />
          </Tabs>
        </MHidden>

        <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: 224 }}>
          <MHidden width="smDown">
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="Vertical tabs"
              sx={{ borderRight: 1, borderColor: 'divider' }}
            >
              <Tab label={t('STG_Privacy')} {...a11yProps(0)} sx={{ textTransform: 'none' }} />
              <Tab label={t('STG_Units')} {...a11yProps(0)} sx={{ textTransform: 'none' }} />
              <Tab
                label={t('STG_ChangePassword')}
                {...a11yProps(1)}
                sx={{ textTransform: 'none' }}
              />
            </Tabs>
          </MHidden>
          <Box sx={{ mt: { xs: 0, sm: -10 } }}>
            <TabPanel value={valueTabs} index={0}>
              <Stack direction="column" justifyContent="center">
                <ContentStyle>
                  <Privacy />
                </ContentStyle>
              </Stack>
            </TabPanel>
            <TabPanel value={valueTabs} index={1}>
              <Stack direction="column" justifyContent="center">
                <ContentStyle>
                  <UnitsChose />
                </ContentStyle>
              </Stack>
            </TabPanel>
            <TabPanel value={valueTabs} index={2}>
              <Stack direction="column" justifyContent="center">
                <PasswordChange />
              </Stack>
            </TabPanel>
          </Box>
        </Box>
      </Container>
    </Page>
  );
}
